module.exports = __webpack_public_path__ + "static/img/index1.5656cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/index1.png
// module id = gaX2
// module chunks = 1